// The Jesus Prayer card in several languages (English, Spanish, French, Arabic, Chinese).
import { JESUS_PRAYER_CARD } from "./prayerRope";

const IMAGE = JESUS_PRAYER_CARD.image;
const SOURCE = JESUS_PRAYER_CARD.source;
const FOOTER = JESUS_PRAYER_CARD.footer;

const L = {
  es: {
    label: "Español",
    eyebrow: "La oración del corazón · para llevar",
    title: "La Oración de Jesús",
    subtitle: "Rezada con el komboskini — el cordón de oración católico oriental",
    prayerLabel: "La oración", prayer: "Señor Jesucristo, Hijo de Dios, ten piedad de mí, pecador.",
    shorterLabel: "Formas más breves", shorter: "Señor Jesucristo, ten piedad de mí.\nSeñor Jesucristo, ten piedad de nosotros.\nSeñor, ten piedad.",
    howLabel: "Cómo rezar con el cordón", how: "Sostén el cordón con suavidad y pasa al siguiente nudo tras cada Oración de Jesús, rezando en voz baja o en el corazón. Cuando la atención se disperse, vuelve con dulzura a las palabras, sin buscar sensaciones ni reiniciar una cuenta. Unos minutos sin prisa son un buen comienzo; el cordón ayuda, pero no es imprescindible.",
    gospelLabel: "Su raíz en el Evangelio", gospel: "La oración une el clamor del publicano — «Dios, ten piedad de mí, que soy pecador» (Lc 18,13) — a la confesión de Cristo como Señor e Hijo de Dios. No es una fórmula que fuerce un resultado, sino un encuentro con Cristo vivo.",
    note: "Forma personal habitual de la Oración de Jesús. Las invocaciones más breves y el plural «ten piedad de nosotros» también pertenecen a la tradición. El Catecismo recomienda la invocación del santo nombre de Jesús.",
    back: { eyebrow: "La oración del corazón", name: "Cristo, amante de la humanidad", blessing: "Señor Jesucristo, Hijo de Dios, ten piedad de mí.\nQue su santo nombre descanse en tu corazón, en cada respiración, hasta hacerse oración incesante." },
  },
  fr: {
    label: "Français",
    eyebrow: "La prière du cœur · à porter",
    title: "La Prière de Jésus",
    subtitle: "Priée sur le komboskini — le chapelet de prière catholique oriental",
    prayerLabel: "La prière", prayer: "Seigneur Jésus Christ, Fils de Dieu, aie pitié de moi, pécheur.",
    shorterLabel: "Formes plus brèves", shorter: "Seigneur Jésus Christ, aie pitié de moi.\nSeigneur Jésus Christ, aie pitié de nous.\nSeigneur, prends pitié.",
    howLabel: "Comment prier avec le chapelet", how: "Tenez la corde avec douceur et passez au nœud suivant après chaque Prière de Jésus, en priant à voix basse ou dans le cœur. Quand l’attention s’égare, revenez doucement aux paroles, sans chercher d’émotions ni recommencer un compte. Quelques minutes sans hâte sont un bon début ; la corde aide, mais n’est pas indispensable.",
    gospelLabel: "Sa racine dans l’Évangile", gospel: "La prière unit le cri du publicain — « Mon Dieu, prends pitié du pécheur que je suis » (Lc 18,13) — à la confession du Christ comme Seigneur et Fils de Dieu. Ce n’est pas une formule qui force un résultat, mais une rencontre avec le Christ vivant.",
    note: "Forme personnelle habituelle de la Prière de Jésus. Les invocations plus brèves et le pluriel « ayez pitié de nous » appartiennent aussi à la tradition. Le Catéchisme recommande l’invocation du saint nom de Jésus.",
    back: { eyebrow: "La prière du cœur", name: "Le Christ, ami des hommes", blessing: "Seigneur Jésus Christ, Fils de Dieu, aie pitié de moi.\nQue son saint nom repose dans ton cœur, à chaque souffle, jusqu’à devenir prière incessante." },
  },
  ar: {
    label: "العربية", dir: "rtl",
    eyebrow: "صلاة القلب · للحمل",
    title: "صلاة يسوع",
    subtitle: "تُصلّى على المسبحة (الكومبوسكيني) — سبحة الصلاة الكاثوليكيّة الشرقيّة",
    prayerLabel: "الصلاة", prayer: "أيّها الربّ يسوع المسيح، يا ابن الله، ارحمني أنا الخاطئ.",
    shorterLabel: "صيغ أقصر", shorter: "أيّها الربّ يسوع المسيح، ارحمني.\nأيّها الربّ يسوع المسيح، ارحمنا.\nيا ربّ، ارحم.",
    howLabel: "كيف تُصلّى بالمسبحة", how: "أمسك الخيط برفق، وانتقل إلى العقدة التالية بعد كلّ صلاةِ يسوع، مُصلّيًا بصوتٍ خفيضٍ أو في القلب. وإذا تشتّت انتباهُك، عُد بلطفٍ إلى الكلمات، دون سعيٍ وراء المشاعرِ أو استئنافِ العدّ. بضع دقائق دون عجلةٍ بدايةٌ حسنة؛ والمسبحة تُعين، لكنّها ليست ضروريّة.",
    gospelLabel: "جذرها في الإنجيل", gospel: "تجمع الصلاة صرخةَ العشّار — «اللهمّ ارحمني أنا الخاطئ» (لوقا ١٨:١٣) — إلى الاعترافِ بالمسيح ربًّا وابنًا لله. ليست صيغةً تفرض نتيجة، بل لقاءٌ بالمسيح الحيّ.",
    note: "صيغةٌ شخصيّةٌ مألوفة لصلاة يسوع. والصيغُ الأقصرُ والجمعُ «ارحمنا» تنتمي أيضًا إلى التقليد. ويوصي التعليمُ المسيحيُّ بدعاءِ اسمِ يسوعَ القدّوس.",
    back: { eyebrow: "صلاة القلب", name: "المسيح، محبّ البشر", blessing: "أيّها الربّ يسوع المسيح، يا ابن الله، ارحمني.\nليَستقرَّ اسمُه القدّوسُ في قلبِك، مع كلِّ نفَس، حتّى يصيرَ صلاةً بلا انقطاع." },
  },
  zh: {
    label: "中文",
    eyebrow: "心祷 · 可随身携带",
    title: "耶稣祷文",
    subtitle: "以祈祷绳（komboskini）诵念——东方天主教的祈祷绳",
    prayerLabel: "祷文", prayer: "主耶稣基督，天主子，求你怜悯我这个罪人。",
    shorterLabel: "较短的形式", shorter: "主耶稣基督，求你怜悯我。\n主耶稣基督，求你怜悯我们。\n主，求你垂怜。",
    howLabel: "如何以祈祷绳诵念", how: "轻握绳结，每念一遍耶稣祷文便移到下一个结，可低声或在心中默祷。当心思游移时，温和地回到经文，不必追求感受，也不必重新计数。不急不忙地祈祷几分钟便是好的开始；绳子有助益，却非必需。",
    gospelLabel: "其在福音中的根源", gospel: "这祷文将税吏的呼求——「天主，可怜我这个罪人吧！」（路十八13）——与承认基督为主、为天主子相结合。它不是强求结果的公式，而是与生活的基督相遇。",
    note: "这是耶稣祷文常见的个人形式。较短的呼求以及复数的「怜悯我们」同样属于传统。《教理》劝勉我们呼求耶稣的圣名。",
    back: { eyebrow: "心祷", name: "基督，人类的挚爱者", blessing: "主耶稣基督，天主子，求你怜悯我。\n愿他的圣名安居你心，与每一次呼吸相偕，直至成为不断的祈祷。" },
  },
};

const localeCard = (code) => {
  const l = L[code]; const dir = l.dir;
  return {
    eyebrow: l.eyebrow, title: l.title, subtitle: l.subtitle, image: IMAGE,
    blocks: [
      { label: l.prayerLabel, text: l.prayer, dir },
      { label: l.shorterLabel, text: l.shorter, dir },
      { label: l.howLabel, text: l.how, dir },
      { label: l.gospelLabel, text: l.gospel, dir },
    ],
    note: l.note, source: SOURCE, back: { ...l.back, blessing: l.prayer, dir }, footer: FOOTER,
  };
};

export const JESUS_CARD_LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "ar", label: "العربية" },
  { code: "zh", label: "中文" },
];

export const buildJesusPrayerCard = (code = "en") =>
  code === "en" ? JESUS_PRAYER_CARD : localeCard(code);
